// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-back-button {
  min-height: 60px;
  color: var(--ion-color-primary-darker);
}
ion-back-button::part(icon) {
  transform: scale(1.3);
  color: white;
}

.header-title {
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
}
@media (min-width: 768px) {
  .header-title {
    font-size: 1.4rem;
  }
}
.header-title ion-text {
  font-weight: bold;
}

@media (min-width: 992px) {
  .menu-button-mobile {
    display: none !important;
  }
}

ion-toolbar {
  --min-height: 56px;
}
@media (min-width: 768px) {
  ion-toolbar {
    --min-height: 64px;
  }
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.title h1 {
  margin: 15px 0;
  letter-spacing: 8.4px;
  color: #707070;
}
.title h1 ion-text {
  display: block;
  letter-spacing: 0px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sCAAA;AACF;AAAE;EACE,qBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EALF;IAMI,iBAAA;EAEF;AACF;AAAE;EACE,iBAAA;AAEJ;;AAIE;EAFF;IAGI,wBAAA;EAAF;AACF;;AAGA;EACE,kBAAA;AAAF;AAEE;EAHF;IAII,kBAAA;EACF;AACF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AACE;EACE,cAAA;EACA,qBAAA;EACA,cAAA;AACJ;AAAI;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;AAEN","sourcesContent":["ion-back-button {\n  min-height: 60px;\n  color: var(--ion-color-primary-darker);\n  &::part(icon) {\n    transform: scale(1.3);\n    color: white;\n  }\n}\n\n.header-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-align: center;\n  \n  @media (min-width: 768px) {\n    font-size: 1.4rem;\n  }\n  \n  ion-text {\n    font-weight: bold;\n  }\n}\n\n.menu-button-mobile {\n  // Ocultar botón de menú en desktop (cuando split-pane esté activo)\n  @media (min-width: 992px) {\n    display: none !important;\n  }\n}\n\nion-toolbar {\n  --min-height: 56px;\n  \n  @media (min-width: 768px) {\n    --min-height: 64px;\n  }\n}\n\n// Estilos legacy para compatibilidad\n.title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  h1 {\n    margin: 15px 0;\n    letter-spacing: 8.4px;\n    color: #707070;\n    ion-text {\n      display: block;\n      letter-spacing: 0px;\n      font-weight: bold;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
